module.exports = __webpack_public_path__ + "img/1525609638.96a4cdd1.jpg";